// STAGING-LAUNCH-READINESS-002-R2 — exit retention: Telegram closing-confirmation sync.
// Kept separate from post-order-session-v2.ts (which repurposes the same Telegram API to
// swallow non-explicit WebApp.close() calls while on the success page — a different concern).

export type ExitRetentionState = "post_order" | "checkout" | "cart" | "browse";

type TelegramWebAppConfirm = {
  enableClosingConfirmation?: () => void;
  disableClosingConfirmation?: () => void;
};

function telegramWebApp(): TelegramWebAppConfirm | undefined {
  return (window as unknown as { Telegram?: { WebApp?: TelegramWebAppConfirm } }).Telegram?.WebApp;
}

export function resolveExitRetentionState(input: {
  viewName: string;
  cartCount: number;
}): ExitRetentionState {
  if (input.viewName === "success") return "post_order";
  if (input.viewName === "checkout") return "checkout";
  if (input.cartCount > 0) return "cart";
  return "browse";
}

/** cart nonempty / checkout incomplete / dirty form => branded sheet only.
 * R2-R7-P0 — never arm Telegram native closing confirmation for ordinary browse/cart;
 * it surfaces as “Changes that you made may not be saved” and fights the branded exit sheet.
 */
export function syncExitClosingConfirmation(_dirty: boolean): void {
  const wa = telegramWebApp();
  if (!wa) return;
  try {
    wa.disableClosingConfirmation?.();
  } catch {
    /* older Telegram clients — non-critical UX enhancement */
  }
}
